import { PersonaSize } from 'fabric-persona/lib/components/Persona.Props';

export default function getPersonaControlKey(
    name: string,
    emailAddress: string,
    personaId: string,
    personaSize: PersonaSize
): string {
    let key = '';

    if (emailAddress) {
        key = emailAddress.toLowerCase();
    } else if (personaId) {
        key = personaId;
    } else {
        key = name.toLowerCase();
    }

    // The persona key is combination of "<identifier>#<personaSize>"
    return `${key}#${personaSize}`;
}
